import { RelatedItemsComponent } from "@webapp/links/components/related-items/related-items.component";
import { downgradeComponent } from "@angular/upgrade/static";
import "angular-drag-and-drop-lists";
import core from "@gtmhub/core/module";
import insightsCore from "@gtmhub/insights/insights-core.module";
import ngExtensions from "@gtmhub/shared/ng-extensions/ng-extensions.module";
import { AllGoalsCtrl } from "./controllers/all";
import { BulkAssignCtrl } from "./controllers/bulk-assign";
import { BulkTagCtrl } from "./controllers/bulk-tag";
import { CloneOrMoveGoalCtrl } from "./controllers/clone-or-move-goal";
import { GoalsCtrl } from "./controllers/goals";
import { GoalTimelineCtrl } from "./controllers/goal-timeline";
import { LinkSelectorGoalsCtrl } from "./controllers/link-selector";
import { ReviewCtrl } from "./controllers/review";
import { SendForApprovalCtrl } from "./controllers/send-for-approval";
import { SubmitToMarketplaceCtrl } from "./controllers/submit-to-marketplace";
import { GoalService } from "./goalService";
import { GoalsTreeService } from "./goalsTreeService";
import { GoalListNode } from "./directives/goal-list-node";
import { SelectAssignees } from "./directives/select-assignee";
import { EditGoalCtrl } from "./controllers/form";
import { GoalCtrl } from "./controllers/goal";
import { SingleGoalSelectorComponent } from "./components/single-goal-selector.component";
import { GoalModalsService } from "@gtmhub/goals/goalModalsService";
import { GoalLinkService } from "@gtmhub/goals/goalLinkService";
import { GoalTagsDirective } from "./directives/goal-tags";
import { GoalSelectorNodeComponent } from "./components/goal-selector-node.component";
import { localizeGridColName } from "./filters";
import { CreateFirstGoalFormComponent } from "./components/create-first-goal-form.component";
import { ContributorComponent } from "./components/contributor/contributor.component";
import { MetricBarTargetComponent } from "./components/metric-bar-target/metric-bar-target.component";
import { MetricBarBooleanComponent } from "./components/metric-bar-boolean/metric-bar-boolean.component";
import { MetricBarProgressComponent } from "./components/metric-bar-progress/metric-bar-progress.component";
import { OkrGridContributorsComponent } from "./components/okr-grid-contributors/okr-grid-contributors.component";
import { OkrMethodologyFacade } from "./components/facades/okr-methodology.facade";

const mod = angular.module("goals", [core, insightsCore, ngExtensions, "dndLists"]);

mod.controller("AllGoalsCtrl", AllGoalsCtrl);
mod.controller("BulkAssignCtrl", BulkAssignCtrl);
mod.controller("BulkTagCtrl", BulkTagCtrl);
mod.controller("CloneOrMoveGoalCtrl", CloneOrMoveGoalCtrl);
mod.controller("EditGoalCtrl", EditGoalCtrl);
mod.controller("GoalCtrl", GoalCtrl);
mod.controller("GoalsCtrl", GoalsCtrl);
mod.controller("GoalTimelineCtrl", GoalTimelineCtrl);
mod.controller("LinkSelectorGoalsCtrl", LinkSelectorGoalsCtrl);
mod.controller("ReviewCtrl", ReviewCtrl);
mod.controller("SendForApprovalCtrl", SendForApprovalCtrl);
mod.controller("SubmitToMarketplaceCtrl", SubmitToMarketplaceCtrl);

mod.service("GoalService", GoalService);
mod.service("GoalLinkService", GoalLinkService);
mod.service("GoalModalsService", GoalModalsService);
mod.service("GoalsTreeService", GoalsTreeService);
mod.service("OkrMethodologyFacade", OkrMethodologyFacade);

mod.directive("goalListNode", GoalListNode.factory());
mod.directive("selectAssignees", SelectAssignees.factory());
mod.directive("goalTags", GoalTagsDirective.factory());
mod.directive("relatedItems", downgradeComponent({ component: RelatedItemsComponent }));

mod.component("singleGoalSelector", SingleGoalSelectorComponent);
mod.component("goalSelectorNode", GoalSelectorNodeComponent);
mod.component("createFirstGoalForm", CreateFirstGoalFormComponent);
mod.component("contributor", ContributorComponent);
mod.component("metricBarTarget", MetricBarTargetComponent);
mod.component("metricBarBoolean", MetricBarBooleanComponent);
mod.component("metricBarProgress", MetricBarProgressComponent);
mod.component("okrGridContributors", OkrGridContributorsComponent);

mod.filter("localizeGridColName", localizeGridColName);

export default mod.name;
